import type { Schemas } from '../../shared/api/client';
import { placesOf } from '../../shared/lib/format';

type Position = Schemas['PositionOut'];

/** Price decimals for an instrument: its tick size, at least 2. */
export function placesFor(position: Pick<Position, 'instrument'>): number {
  return placesOf(position.instrument.tick_size);
}

export function triggeredLevels(position: Position): Schemas['LevelOut'][] {
  return position.levels.filter((l) => l.status === 'triggered');
}

/** The level the owner would act on next: triggered first, then the next pending one. */
export function nextLevelOf(position: Position): Schemas['LevelOut'] | undefined {
  return (
    position.levels.find((l) => l.n > 0 && l.status === 'triggered') ??
    position.levels.find((l) => l.n > 0 && l.status === 'pending')
  );
}
